<form id="userEditForm" [formGroup]="userEditForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="firstname" class="control-label" [ngClass]="{'required': !userEditForm.controls.firstname.disabled}">{{
        'i18n.base.user-add-modal.firstname' | translate }}</label>
      <input id="firstname" name="firstname" type="text" autocomplete="off" class="form-control" formControlName="firstname" />
      <app-error-messages [control]="formFields.firstname"></app-error-messages>
    </div>

    <div class="form-group col-md-6">
      <label for="lastname" class="control-label" [ngClass]="{'required': !userEditForm.controls.lastname.disabled}">{{
        'i18n.base.user-add-modal.lastname' | translate }}</label>
      <input id="lastname" name="lastname" type="text" autocomplete="off" class="form-control" formControlName="lastname" />
      <app-error-messages [control]="formFields.lastname"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="email" class="control-label" [ngClass]="{'required': !userEditForm.controls.email?.disabled}">{{
        'i18n.base.user-add-modal.email' | translate }}</label>
      <input id="email" name="email" type="email" autocomplete="off" class="form-control" formControlName="email" />
      <app-error-messages [control]="formFields.email"></app-error-messages>
    </div>
  </div>
  @if (!isAdd) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <div class="d-flex gap-1">
          <label for="userName" class="control-label" [ngClass]="{'required': !userEditForm.controls.userName.disabled}">{{
          'i18n.base.user-add-modal.userName' | translate }}</label>
          <ejs-tooltip id='tooltip' content="{{ 'i18n.base.user-add-modal.userNameGenerationInfo' | translate }}">
            <span class="icon-information"></span>
          </ejs-tooltip>
        </div>
        <input id="userName" name="userName" type="text" autocomplete="off" class="form-control" formControlName="userName" />
        <app-error-messages [control]="formFields.userName"></app-error-messages>
      </div>
    </div>
  }
  <div class="form-row row">
    @if (!hideClient() && initialRole !== Role.User) {
      <div class="form-group col-md-6">
        <label class="control-label" [ngClass]="{'required': isAdd}">{{ 'i18n.base.user-management.column-headers.client' | translate }}</label>
        <app-client-autocomplete class="client-autocomplete" formControlName="client"
          placeholder=""></app-client-autocomplete>
        <app-error-messages [control]="formFields.client"></app-error-messages>
      </div>
    }
    @if (!hideClient() && initialRole !== Role.User) {
      <div class="form-group col-md-6">
        <label class="control-label">{{
          'i18n.base.user-management.column-headers.company' | translate }}</label>
          <ejs-dropdownlist #companydd [dataSource]="companiesData" [fields]="dropdownSettings" [showClearButton]="true"
          id="companyId" formControlName="companyId">
        </ejs-dropdownlist>
        <app-error-messages [control]="formFields.companyId"></app-error-messages>
      </div>
    }
  </div>
  <div class="form-row row">
    <div class="form-group col-md-{{hideClient()?'12':'6'}}">
      <label class="control-label" [ngClass]="{'required': !userEditForm.controls.language?.disabled}">{{
        'i18n.base.user-add-modal.language' | translate }}</label>
      <ejs-dropdownlist [dataSource]="languageDropDowItems" [fields]="languageDropdownSettings" [showClearButton]="true"
        id="language" formControlName="language">
      </ejs-dropdownlist>
      <app-error-messages [control]="formFields.language"></app-error-messages>
    </div>
  </div>
  @if (initialRole === Role.User) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="control-label" [ngClass]="{'required': !formFields.fullAddress?.disabled}">
          {{'i18n.base.user-add-modal.address' | translate }}
        </label>
        <app-address-autofill [addressForm]="userEditForm"></app-address-autofill>
        <app-error-messages [control]="formFields.fullAddress"></app-error-messages>
      </div>
    </div>
  }
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="phoneNumber" [ngClass]="{'control-label required': isParkingRanger}">{{
        'i18n.base.user-add-modal.phoneNumber' | translate }}</label>
      <input id="phoneNumber" name="phoneNumber" type="text" autocomplete="off" class="form-control" formControlName="phoneNumber" />
      <app-error-messages [control]="formFields.phoneNumber"></app-error-messages>
    </div>
  </div>

  @if ((initialRole === Role.ClientUser || initialRole == Role.ClientAdmin) && !isLoggedInUser) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block control-label"
          [ngClass]="{'required': !userEditForm.controls.role.disabled}">{{'i18n.base.user-add-modal.role' |
          translate}}</label>
        <app-button-group [fieldsEnum]="Role" id="role" [hide]="hiddenRoles" formControlName="role"
          [translateKey]="'i18n.shared.roles.'"></app-button-group>
      </div>
    </div>
  }
  @if (!isAdd && !isLoggedInUser) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block">{{ 'i18n.base.user-add-modal.enabled' | translate }}</label>
        <app-yes-no-group-button id="enabled" formControlName="enabled"></app-yes-no-group-button>
      </div>
    </div>
  }
  @if (!isAdd && !isLoggedInUser) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block">{{ 'i18n.base.user-add-modal.validated' | translate }}</label>
        <app-yes-no-group-button id="validated" formControlName="validated"></app-yes-no-group-button>
      </div>
    </div>
  }
  @if (initialRole === Role.User) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <app-deposited-number-plates [(controlPlates)]="controlPlates"></app-deposited-number-plates>
      </div>
    </div>
    <div class="form-row row">
      <div class="form-group col-md-12">
        @if (linkedParkers.length) {
          <app-linked-parker [(linkedParkers)]="linkedParkers"></app-linked-parker>
        }
      </div>
    </div>
  }
</form>
